import api from "utils/api";

export const getMyOrderHistory = async (page = 1) => {
    try {
        const res = await api.get("/buccl_main/api/v1/orders/my/", {
            params: { page },
        });
        return res.data;
    } catch (err) {
        console.error("주문 내역 조회 오류:", err);
    }
};


export const getOrderDetail = async (orderId) => {
    try {
        const res = await api.get(`buccl_main/api/v1/orders/my/${orderId}/`);
        return res.data;
    } catch (err) {
        console.error("주문 상세 조회 오류:", err);
    }
};

export const cancelOrder = async (orderId) => {
    const res = await api.post(`/buccl_main/api/v1/products/orders/${orderId}/cancel/`);
    return res.data;
};

export const confirmPurchase = async (orderId) => {
    const res = await api.post(`/buccl_main/api/v1/orders/my/${orderId}/confirm-purchase/`);
    return res.data;
};